<template>
    <div class="content">
        <pageTool></pageTool>
        <Header
            :page-title="title"
        ></Header>
<!--        <topNav2-->
<!--            :nav-config="navConfig"-->
<!--            @navClick="navClick"-->
<!--        ></topNav2>-->
        <infoCard
            :list-data="demandList0"
            @cardEvent="handleCardEvent"
        ></infoCard>
        <infoCard
            :list-data="demandList1"
            @cardEvent="handleCardEvent"
        ></infoCard>
        <infoCard
            :list-data="demandList2"
            @cardEvent="handleCardEvent"
        ></infoCard>
        <infoCard
            :list-data="demandList3"
            @cardEvent="handleCardEvent"
        ></infoCard>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
// import topNav2 from "@/components/nav/topNav2"
import infoCard from "@/components/card/infoCard"
import {onMounted, reactive} from "@vue/runtime-dom"
import pageTool from "@/components/nav/pageTool"
const banner = require('@/assets/img/page_banner_1.png')
const icon0 = require('@/assets/img/icon6.png')
const icon1 = require('@/assets/img/icon7.png')
const icon2 = require('@/assets/img/icon8.png')
const icon3 = require('@/assets/img/icon9.png')
import { getProcessList } from '@/api/policy'
import {useRouter} from "vue-router"
export default {
    name: "NewSubjectInfo",
    setup() {
        const router = useRouter()
        const title = {
            cn: '示范性主体申报',
            en: 'DEMONSTRATIVE ENTITY DECLARATION',
            hasSearch: true,
            titleStyle: false,
            banner
        }
        const navConfig = [
            {name: '龙头企业申报', icon: icon0},
            {name: '合作社申报', icon: icon1},
            {name: '家庭农场申报', icon: icon2},
            {name: '服务组织申报', icon: icon3},
        ]
        const demandList0 = reactive({
            title: '龙头企业评定标准',
            secId: 200011,
            list: []
        })
        const demandList1 = reactive({
            title: '合作社申报',
            secId: 200016,
            list: []
        })
        const demandList2 = reactive({
            title: '家庭农场申报',
            secId: 200015,
            list: []
        })
        const demandList3 = reactive({
            title: '服务组织申报',
            secId: 200012,
            list: []
        })
        const rtData = reactive({
            listData: []
        })
        const initList = (id, fnc) => {
            const params = {"current": 1,"model": {"secondCategoryId": id}, "size": 100}
            getProcessList(params).then(res => {
                const list = res.records.map(k => ({
                    id: k.id,
                    date: k.createTime,
                    title: k.title,
                }))
                fnc.list = list
            })
        }
        const navClick = (i) => {
            console.log(i)
        }
        const handleCardEvent = (evt) => {
            // router.push({ name: 'NewSubjectDetail', params: {params: JSON.stringify(evt)}})
            router.push({ name: 'NewSubjectDetail', query: {params: JSON.stringify(evt)}})
        }
        onMounted(() => {
            initList(200011, demandList0)
            initList(200016, demandList1)
            initList(200015, demandList2)
            initList(200012, demandList3)
        })
        return {
            title,
            navConfig,
            navClick,
            demandList0,
            demandList1,
            demandList2,
            demandList3,
            rtData,
            initList,
            handleCardEvent
        }
    },
    components: {
        Header,
        // topNav2,
        infoCard,
        pageTool
    }
}
</script>

<style scoped lang="stylus">
.content {
    background-color #FFF
}

.page-content {
    padding 20px 30px
}
</style>